import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "casablanca-commerce",
  founder: "Yasmine El Amrani",
  company: "Souk+",
  city: "Casablanca",
  country: "Maroc",
  pillar: "microservices",
  outcomeShort: {
    en: "Launched in 6 weeks, €12k GMV in month 1",
    fr: "Lancé en 6 semaines, 12 k€ GMV au mois 1",
  },
  title: {
    en: "Souk+ launched a multi-vendor marketplace in 6 weeks",
    fr: "Souk+ a lancé une marketplace multi-vendeurs en 6 semaines",
  },
  subtitle: {
    en: "Branding, Stripe-equivalent payments, and Arabic-first UX delivered as fixed-scope microservices.",
    fr: "Branding, paiement équivalent Stripe et UX arabe-first livrés en microservices à périmètre fixe.",
  },
  body: {
    en: {
      context: "Yasmine had a verified marketplace concept for Moroccan artisans but no team and a 6-week deadline before Ramadan.",
      challenge: "She needed brand identity, mobile-first checkout supporting CMI (the local card network), Arabic RTL UX, and seller onboarding — all on a €15k budget.",
      approach: "We bundled 4 microservices: Brand-in-a-Week (€2.5k), Checkout-CMI integration (€4k), RTL UX kit (€3k), and Seller-Onboarding-Flow (€3.5k). Each shipped in parallel.",
      outcome: "Live 4 days before Ramadan with 47 onboarded artisans. Did €12,000 GMV in month 1 and 1,400 transactions.",
      quote: "I didn't need an agency. I needed four specialists, each shipping in their lane.",
      quoteAuthor: "Yasmine El Amrani · Founder, Souk+",
    },
    fr: {
      context: "Yasmine avait un concept de marketplace validé pour les artisans marocains mais pas d'équipe et un deadline de 6 semaines avant le Ramadan.",
      challenge: "Il fallait identité de marque, checkout mobile-first compatible CMI (le réseau carte local), UX arabe RTL, et onboarding vendeurs — le tout pour 15 k€.",
      approach: "Nous avons assemblé 4 microservices : Brand-in-a-Week (2,5 k€), intégration Checkout-CMI (4 k€), kit UX RTL (3 k€), et Seller-Onboarding-Flow (3,5 k€). Chacun livré en parallèle.",
      outcome: "En ligne 4 jours avant le Ramadan avec 47 artisans onboardés. 12 000 € de GMV au mois 1 et 1 400 transactions.",
      quote: "Je n'avais pas besoin d'une agence. J'avais besoin de quatre spécialistes, chacun livrant dans son couloir.",
      quoteAuthor: "Yasmine El Amrani · Fondatrice, Souk+",
    },
  },
};
export default cs;
